function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Glasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "15",
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4856 2.0673c-.3158-.7572-1.2453-1.0361-1.9258-.578l-3.42 2.3025c-.8613.5798-.7287 1.8856.2315 2.2806l.1216.05.2282-.5549-.1216-.05c-.517-.2127-.5884-.9158-.1246-1.228l3.42-2.3025c.3664-.2467.8669-.0965 1.037.3112l.0748.1795a.3.3 0 0 0 .5537-.231l-.0748-.1795Z",
    fill: "#528693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7363 8.289-.2116.453-.906-.4233.2116-.453.906.4234Z",
    fill: "#528793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.391 9.9236c1.5958.7593 3.5051.0811 4.2644-1.5148.7593-1.596.081-3.5052-1.5148-4.2644-1.5959-.7593-3.5051-.0811-4.2644 1.5148-.7593 1.5958-.0811 3.505 1.5148 4.2644Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1883 8.7645a3.2004 3.2004 0 0 1-.3446-.514l5.955-2.1168c.0388.203.0579.4094.0568.6162L3.1883 8.7644Zm4.8102-4.212L2.468 6.517a3.2001 3.2001 0 0 0 .1588 1.2118l6.0129-2.136a3.2002 3.2002 0 0 0-.6412-1.0403Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4255 9.3845c1.4463.6881 3.1766.0735 3.8647-1.3728.688-1.4463.0735-3.1765-1.3728-3.8646-1.4463-.6881-3.1765-.0735-3.8646 1.3728-.6882 1.4462-.0735 3.1765 1.3727 3.8646Zm-.2577.5418c1.7455.8305 3.8337.0887 4.6642-1.6568.8304-1.7455.0887-3.8338-1.6568-4.6642-1.7455-.8305-3.8338-.0887-4.6643 1.6568-.8304 1.7455-.0886 3.8337 1.6569 4.6642Z",
    fill: "#528793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3275 12.7751c1.5959.7593 3.5051.0811 4.2644-1.5148.7593-1.5959.0811-3.5051-1.5148-4.2644-1.5959-.7593-3.5051-.081-4.2644 1.5148-.7593 1.5959-.0811 3.5052 1.5148 4.2644Z",
    fill: "#BFF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1248 11.616a3.2048 3.2048 0 0 1-.3446-.5139l5.9551-2.1168c.0388.203.0578.4094.0568.6161l-5.6673 2.0146Zm4.8102-4.212L9.4045 9.3687a3.1998 3.1998 0 0 0 .1588 1.2117l6.0129-2.1358a3.1995 3.1995 0 0 0-.6412-1.0404Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3621 12.2361c1.4462.6881 3.1765.0734 3.8646-1.3728.6881-1.4463.0735-3.1766-1.3728-3.8647-1.4463-.688-3.1765-.0735-3.8646 1.3728-.6881 1.4463-.0735 3.1766 1.3728 3.8647Zm-.2578.5418c1.7455.8304 3.8337.0887 4.6642-1.6568.8305-1.7455.0887-3.8338-1.6568-4.6643-1.7455-.8304-3.8338-.0887-4.6642 1.6568-.8305 1.7455-.0887 3.8338 1.6568 4.6643Z",
    fill: "#528793"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7461 5.0551c.7572-.3158 1.614.14 1.7751.9444l.81 4.0424c.204 1.0181-.809 1.8527-1.7692 1.4577l-.1216-.05.2283-.5549.1216.05c.517.2127 1.0625-.2367.9526-.7849l-.81-4.0424c-.0868-.4331-.5481-.6786-.9558-.5085l-.1794.0748a.3.3 0 0 1-.231-.5538l.1794-.0748Z",
    fill: "#528693"
  }));
}

export default Glasses;